import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import { Input } from './elements';
import { useText } from 'common/hooks';

function getErrorMessage(codeError, joiningError, t) {
  const error = codeError || joiningError;

  if (error) {
    const errorPath = `errors.${error}`;

    if (t.has(errorPath)) return t(errorPath);

    return t('errors.error');
  }

  return null;
}

const deps = {
  code: state.account.joinCampaign.code,
  codeNames: state.account.joinCampaign.codeNames,
  codeError: state.account.joinCampaign.codeError,
  isValidating: state.account.joinCampaign.isValidatingCode,
  isJoining: state.account.joinCampaign.isJoining,
  joiningError: state.account.joinCampaign.joiningError,
  campaignKey: state.account.joinCampaign.campaignKey,
  codeChanged: sequences`account.joinCampaign.codeChanged`,
  joinCampaignCode: sequences`account.joinCampaign.joinCampaignCode`,
};

export function CampaignCodeInput({
  code,
  codeChanged,
  isValidating,
  codeNames,
  codeError,
  joiningError,
  campaignKey,
  isJoining,
  joinCampaignCode,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Input
      aria-labelledby={'timeline-join-campaign timeline-enter-code'}
      value={code}
      onChange={event =>
        codeChanged({ value: event.target.value, campaignKey })
      }
      challengeName={codeNames.campaign}
      sectionName={codeNames.section}
      teamName={codeNames.team}
      isValidating={isValidating}
      validCode={Boolean(codeNames.campaign)}
      placeholder={t('account.join_campaign.code.code_placeholder')}
      checkingText={t('account.join_campaign.code.check_code')}
      participateText={t('account.join_campaign.code.ok')}
      error={getErrorMessage(codeError, joiningError, t)}
      participateButtonDisabled={isJoining}
      participateClicked={() => joinCampaignCode()}
    />
  );
}

export default connect(deps, CampaignCodeInput);
